var CareAppListActionFactory = /** @class */ (function () {
    function CareAppListActionFactory(type) {
        this.type = type;
    }
    Object.defineProperty(CareAppListActionFactory.prototype, "REQUEST_ALL", {
        get: function () {
            return "[" + this.type + "][Request] All";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "REQUEST_BY_ID", {
        get: function () {
            return "[" + this.type + "][Request] By ID";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "SELECT_BY_ID", {
        get: function () {
            return "[" + this.type + "][Select] By ID";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "RESPONSE_SUCCESS_ALL", {
        get: function () {
            return "[" + this.type + "][Response][Success] All";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "RESPONSE_FAIL_ALL", {
        get: function () {
            return "[" + this.type + "][Response][Fail] All";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "RESPONSE_SUCCESS_BY_ID", {
        get: function () {
            return "[" + this.type + "][Response][Success] By ID";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "RESPONSE_FAIL_BY_ID", {
        get: function () {
            return "[" + this.type + "][Response][Fail] By ID";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "RESPONSE_FAIL", {
        get: function () {
            return "[" + this.type + "][Response][Fail] Generic";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "REQUEST_CREATE", {
        get: function () {
            return "[" + this.type + "][Request] Create";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "RESPONSE_SUCCESS_CREATE", {
        get: function () {
            return "[" + this.type + "][Response][Success] Create";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "RESPONSE_FAIL_CREATE", {
        get: function () {
            return "[" + this.type + "][Response][Fail] Create";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "REQUEST_SAVE", {
        get: function () {
            return "[" + this.type + "][Request] Save";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "RESPONSE_SUCCESS_SAVE", {
        get: function () {
            return "[" + this.type + "][Response][Success] Save";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "RESPONSE_FAIL_SAVE", {
        get: function () {
            return "[" + this.type + "][Response][Fail] Save";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "PAGE_CHANGE", {
        get: function () {
            return "[" + this.type + "][Request] Paginate";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "UPDATE_FILTER", {
        get: function () {
            return "[" + this.type + "][Request] Update Filter";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "RESET_PAGE", {
        get: function () {
            return "[" + this.type + "][Request] Reset Pagination";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "REQUEST_PAGE", {
        get: function () {
            return "[" + this.type + "][Request] Update Page";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "REQUEST_COUNT", {
        get: function () {
            return "[" + this.type + "][Request] Count";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "RESPONSE_SUCCESS_COUNT", {
        get: function () {
            return "[" + this.type + "][Response][Success] Count";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "RESPONSE_FAIL_COUNT", {
        get: function () {
            return "[" + this.type + "][Response][Fail] Count";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "REQUEST_SEARCH", {
        get: function () {
            return "[" + this.type + "][Request] Search";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "RESPONSE_SUCCESS_SEARCH", {
        get: function () {
            return "[" + this.type + "][Response][Success] Search";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "RESPONSE_FAIL_SEARCH", {
        get: function () {
            return "[" + this.type + "][Response][Fail] Search";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "REQUEST_DESTROY_BY_ID", {
        get: function () {
            return "[" + this.type + "][Request] Destroy By ID";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "RESPONSE_SUCCESS_DESTROY_BY_ID", {
        get: function () {
            return "[" + this.type + "][Response][Success] Destroy By ID";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "RESPONSE_FAIL_DESTROY_BY_ID", {
        get: function () {
            return "[" + this.type + "][Response][Fail] Destroy By ID";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CareAppListActionFactory.prototype, "RequestAllAction", {
        get: function () {
            return {
                type: this.REQUEST_ALL
            };
        },
        enumerable: true,
        configurable: true
    });
    CareAppListActionFactory.prototype.RequestByIdAction = function (payload) {
        if (typeof payload !== 'object') {
            throw new Error('Request by id sction requires object payload');
        }
        return {
            type: this.REQUEST_BY_ID,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.SelectByIdAction = function (payload) {
        if (typeof payload !== 'object') {
            throw new Error('Select by id action requires object payload');
        }
        return {
            type: this.SELECT_BY_ID,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.ResponseSuccessAllAction = function (payload) {
        return {
            type: this.RESPONSE_SUCCESS_ALL,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.ResponseSuccessByIdAction = function (payload) {
        return {
            type: this.RESPONSE_SUCCESS_BY_ID,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.ResponseFailByIdAction = function (payload) {
        return {
            type: this.RESPONSE_FAIL_BY_ID,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.ResponseFailAction = function (payload) {
        return {
            type: this.RESPONSE_FAIL,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.ResponseFailAllAction = function (payload) {
        return {
            type: this.RESPONSE_FAIL_ALL,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.RequestCreateAction = function (payload) {
        return {
            type: this.REQUEST_CREATE,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.ResponseSuccessCreateAction = function (payload) {
        return {
            type: this.RESPONSE_SUCCESS_CREATE,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.ResponseFailCreateAction = function (payload) {
        return {
            type: this.RESPONSE_FAIL_CREATE,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.RequestSaveAction = function (payload) {
        if (!payload.id) {
            throw new Error('Save action payload must have an id');
        }
        return {
            type: this.REQUEST_SAVE,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.ResponseSuccessSaveAction = function (payload) {
        return {
            type: this.RESPONSE_SUCCESS_SAVE,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.ResponseFailSaveAction = function (payload) {
        return {
            type: this.RESPONSE_FAIL_SAVE,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.PageChangeAction = function (payload) {
        return {
            type: this.PAGE_CHANGE,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.ResetPageAction = function () {
        return {
            type: this.RESET_PAGE
        };
    };
    CareAppListActionFactory.prototype.RequestPageAction = function () {
        return {
            type: this.REQUEST_PAGE
        };
    };
    CareAppListActionFactory.prototype.UpdateFilterAction = function (payload) {
        return {
            type: this.UPDATE_FILTER,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.RequestCountAction = function () {
        return {
            type: this.REQUEST_COUNT
        };
    };
    CareAppListActionFactory.prototype.ResponseSuccessCountAction = function (payload) {
        return {
            type: this.RESPONSE_SUCCESS_COUNT,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.ResponseFailCountAction = function (payload) {
        return {
            type: this.RESPONSE_FAIL_COUNT,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.RequestSearchAction = function (payload) {
        return {
            type: this.REQUEST_SEARCH,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.ResponseSuccessSearchAction = function (payload) {
        return {
            type: this.RESPONSE_SUCCESS_SEARCH,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.ResponseFailSearchAction = function (payload) {
        return {
            type: this.RESPONSE_FAIL_SEARCH,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.RequestDestroyByIdAction = function (payload) {
        return {
            type: this.REQUEST_DESTROY_BY_ID,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.ResponseSuccessDestroyByIdAction = function (payload) {
        return {
            type: this.RESPONSE_SUCCESS_DESTROY_BY_ID,
            payload: payload
        };
    };
    CareAppListActionFactory.prototype.ResponseFailDestroyByIdAction = function (payload) {
        return {
            type: this.RESPONSE_FAIL_DESTROY_BY_ID,
            payload: payload
        };
    };
    return CareAppListActionFactory;
}());
export { CareAppListActionFactory };
